import moment from 'moment';
import React, { useState } from 'react';

import { translate } from '@vestahealthcare/common/i18n';

import { FilterSelectable, Modal } from 'styleguide-v2';

import { showGlobalError } from '../../../../../components/GlobalMessage';
import { deletePODShuffleMembers } from '../../../../../services/PodServices';
import { PODShuffleResultsFilters } from './PODShuffleResultsFilterBar';

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  selection: number[];
  filters?: PODShuffleResultsFilters;
  allSelected: boolean;
}

const DeletePODShuffleModal = ({
  open,
  onClose,
  onSubmit,
  selection,
  filters,
  allSelected,
}: Props) => {
  const [loading, setLoading] = useState(false);

  const handleFinalConfirm = () => {
    setLoading(true);
    return deletePODShuffleMembers({
      podShuffleMemberIds: allSelected ? [] : selection,
      ...(allSelected
        ? {
            filter: {
              month: moment(
                (filters?.month?.value as FilterSelectable)?.value,
              ).format('YYYY-MM-DD'),
              podId: (filters?.podId?.value as FilterSelectable)?.value,
              excludedPodShuffleMemberIds: selection,
            },
          }
        : {}),
    })
      .then(() => {
        setLoading(false);
        onSubmit();
        onClose();
      })
      .catch((e) => {
        showGlobalError(e);
        setLoading(false);
        return false;
      });
  };

  return (
    <Modal
      maxWidth="xs"
      color="warning"
      title={
        <>
          <i className="fa fa-warning" />{' '}
          {translate('pods.shuffle.results.confirmDelete')}
        </>
      }
      onClose={onClose}
      onSubmit={handleFinalConfirm}
      open={open}
      submitDisabled={loading}
      onCancel={onClose}
    >
      <p>
        {translate('pods.shuffle.results.confirmDeleteMessage', {
          month: (filters?.month?.value as FilterSelectable)?.label as string,
        })}
      </p>
    </Modal>
  );
};

export default DeletePODShuffleModal;
